import { useFeatureGate } from '~/hooks/useFeatureGate';

import { TRIAL_MAX_DATA_ROWS } from '../utils/validate-catalog-file';

/** Trial product pool when the `trial-max-20` flag is off — the standard cap. */
export const TRIAL_DEFAULT_PRODUCT_LIMIT = 500;

/** Result of the trial product-limit lookup. */
export interface TrialProductLimit {
  /** True when the `trial-max-20` flag is on — the cap is 20 and uploads are row-limited. */
  isMaxTwenty: boolean;
  /** The product limit to display/enforce: 20 when the flag is on, else 500. */
  limit: number;
}

/**
 * Resolves the trial product limit shown and enforced across the trial flow.
 * When the `trial-max-20` flag is on, the cap drops to `TRIAL_MAX_DATA_ROWS`
 * (20) and catalog uploads are row-limited; otherwise the default 500-product
 * pool applies. Centralises the flag read so copy and validation stay in sync.
 */
export function useTrialProductLimit(): TrialProductLimit {
  const { isAllowed: isMaxTwenty } = useFeatureGate('trial_max_20');
  return {
    isMaxTwenty,
    limit: isMaxTwenty ? TRIAL_MAX_DATA_ROWS : TRIAL_DEFAULT_PRODUCT_LIMIT,
  };
}
